export const URL = {
  KNOWLEDGE_BASE: 'https://knowledge-base.yieldbird.com',
  REPORT_BUG:
    'https://docs.google.com/forms/d/1ImxEJ_OBh0nCXc6vrNk3mt2eHqRqq113IA8niN3WIFE/viewform?edit_requested=true',
  WHATS_NEW: 'https://knowledge-base.yieldbird.com/yieldbird-platform-release-notes',
} as const

export const PRODUCT_TEAM_EMAIL = 'product@yieldbird.com'

export const MAILTO_LINE_BREAK = '\r\n'
export const MAILTO_EMPTY_LINE = ''
